__turbopack_context__.v({
  "sup": "mixins-module__kDFmYq__sup",
});
